import React, { useState, useEffect } from 'react';
import DashboardCarousel from '../../../Common/DashboardCarousel/DashboardCarousel';
import requestAxios from '../../../../util/requestAxios';
import './Products2.css';

const Products = () => { 
       const [listServices, setListServices] = useState([]);

    useEffect(() => {
        getInfo();
    }, []);
    const getInfo = async () => {
        const url = `Home/GetOolaProducts/2`;
        const { error, data } = await requestAxios({
            url: url,
        });
        if (error) {
            console.log(error);
        } else {
            setListServices(data);
        }
    };
    return (
        <div className="HomePageProducts__Container">
            <h1>
                PRODUCTS <hr />
            </h1>
            <p className="paragraph-2">
                Science-based Nootropic  and Adaptogen blends
                specifically 
                formulated to give you the nutritional support and energy to

                crush your life goals.
            </p>
            <DashboardCarousel listServices={listServices}/>
            
        </div>
    );
};

export default Products;
